module.exports = __webpack_public_path__ + "static/media/menu_blue.02048709.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/forum/menu_blue.svg
// module id = ./src/assets/media/forum/menu_blue.svg
// module chunks = 16